<template>
  <v-timeline-item
    dot-color="userActivity"
    icon="mdi-information-variant"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      variant="accordion"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row
            no-gutters
            align="center"
            class="d-flex justify-center"
            :class="{ 'flex-column': $vuetify.display.smAndDown }"
          >
            <v-col md="8">
              <div class="mb-2 text-subtitle-1">
                {{ $t('lead-timeline.lead-imported.title') }}
              </div>
              <div class="text-grey">
                {{ $t('lead-timeline.lead-imported.subtitle') }}
              </div>
            </v-col>
            <v-col
              class="pr-2 text-right text-grey"
              :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row>
            <v-col md="4">
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title> {{ $t('labels.contact') }}: </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ name }}
                  </div>
                  <div class="text-grey text--darken-3 text-body-2">
                    <span> {{ phone }} </span>
                  </div>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>
<script>
import currencyMixin from '@/mixins/currency'

import LEAD from '../queries/Lead.gql'

export default {
  mixins: [currencyMixin],

  props: {
    data: { type: Object, default: null },
    leadId: { type: String, default: '' },
  },
  computed: {
    name() {
      if (!this.lead) return
      return `${this.lead.firstname} ${this.lead.lastname}`
    },
    phone() {
      if (!this.lead) return
      return this.lead.phone
    },
  },
  apollo: {
    lead: {
      query: LEAD,
      variables() {
        return {
          id: this.leadId,
        }
      },
    },
  },
}
</script>

<style scoped>
.expansion-panels {
  margin: -24px -24px 0 -24px;
}
</style>
